import businessAnalysisImage from "../../media/work-stages/business-analysis.webp";
import developmentImage from "../../media/work-stages/development.webp";
import launchImage from "../../media/work-stages/launch.webp";
import projectingImage from "../../media/work-stages/projecting.webp";
import testingImage from "../../media/work-stages/testing.webp";
import maintainingImage from "../../media/work-stages/maintaining.webp";


export const tabsName = ['Strategic IT Consulting', 'Software Development', 'Software Implementation and Support']


export const tabsBlocks = {
    'Strategic IT Consulting': [
        {
            title: "workStages.blocks.businessAnalysis.title",
            content: [
                "workStages.blocks.businessAnalysis.body.0",
                "workStages.blocks.businessAnalysis.body.1",
            ],
            imageUrl: businessAnalysisImage,
        },
    ],
    'Software Development':[

        {
            title: "workStages.blocks.design.title",
            content: [
                "workStages.blocks.design.body.0",
                "workStages.blocks.design.body.1",
            ],
            imageUrl: projectingImage,
        },
        {
            title: "workStages.blocks.development.title",
            content: [
                "workStages.blocks.development.body.0",
                "workStages.blocks.development.body.1",
            ],
            imageUrl: developmentImage,
        },
        {
            title: "workStages.blocks.testing.title",
            content: ["workStages.blocks.testing.body.0"],
            imageUrl: testingImage,
        },
    ],
    'Software Implementation and Support': [
        {
            title: "workStages.blocks.implementationAndLaunch.title",
            content: [
                "workStages.blocks.implementationAndLaunch.body.0",
                "workStages.blocks.implementationAndLaunch.body.1",
            ],
            imageUrl: launchImage,
        },
        {
            title: "workStages.blocks.supportAndDevelopment.title",
            content: ["workStages.blocks.supportAndDevelopment.body.0"],
            imageUrl: maintainingImage,
        },
    ]
}